/* src/app/burden/burden-container/burden-container.component.scss */
/*# sourceMappingURL=burden-container.component.css.map */
